import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { IdentityProvider } from "@planzone/dto";

import { TextInput } from "@common/textInput";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import { ScopeSelect } from "./scopeSelect";
import styles from "./styles.scss";

function AzureForm({ identityProvider, edit }: Props) {
  const { t } = useTranslation();
  const e = (nextConf: IdentityProvider["config"]) =>
    edit({
      ...identityProvider,
      config: { ...identityProvider.config, ...nextConf },
    });

  return (
    <div className={styles.azureForm}>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.clientId.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["id"] || ""}
            placeholder={t("addIdentityProvider.azure.clientId.placeholder")}
            input={(value) => e({ id: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.clientSecret.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["secret"] || ""}
            placeholder={t(
              "addIdentityProvider.azure.clientSecret.placeholder",
            )}
            input={(value) => e({ secret: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.tenant.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["tenant"] || ""}
            placeholder={t("addIdentityProvider.azure.tenant.placeholder")}
            input={(value) => e({ tenant: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.discoveryUri.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["discovery_uri"] || ""}
            placeholder={t(
              "addIdentityProvider.azure.discoveryUri.placeholder",
            )}
            input={(value) => e({ discovery_uri: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>Scope:</p>
        <div className={styles.form}>
          <ScopeSelect
            selectedScopes={(identityProvider.config["scope"] || "").split(",")}
            select={(scopes) => e({ scope: scopes.join(",") })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.callbackUrlType.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["callback_url_type"] || ""}
            placeholder={t(
              "addIdentityProvider.azure.callbackUrlType.placeholder",
            )}
            input={(value) => e({ callback_url_type: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.displayName.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["display_name"] || ""}
            placeholder={t("addIdentityProvider.azure.displayName.placeholder")}
            input={(value) => e({ display_name: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.clientName.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["client_name"] || ""}
            placeholder={t("addIdentityProvider.azure.clientName.placeholder")}
            input={(value) => e({ client_name: value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.principalAttributeId.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["principalAttributeId"] || ""}
            placeholder={t(
              "addIdentityProvider.azure.principalAttributeId.placeholder",
            )}
            input={(value) => e({ principal_attribute_id: value })}
          />
        </div>
      </div>
      <div className={styles.checkboxGroup}>
        <p className={styles.label}>
          {t("addIdentityProvider.azure.enabled")}:
        </p>
        <div
          className={classNames(styles.form, styles.checkbox)}
          onClick={() =>
            edit({
              ...identityProvider,
              isEnabled: !identityProvider.isEnabled,
            })
          }
        >
          <Checkbox isChecked={identityProvider.isEnabled} />
        </div>
      </div>
    </div>
  );
}

export { AzureForm };
